import { map } from 'ramda';

const Material = {
  schema: {
    color: { label: 'Color', type: 'Color', defaultValue: { r: 0.94, g: 0.94, b: 0.94 } },
  },
  update: (operator, primitive) => {
    return primitive.color = operator.color;
  },
};

const Physical = {
  environment: true,

  schema: {
    baseMap: { label: 'Image', type: 'Plug', plug: 'Image' },
    baseMapTransparent: { label: 'Image Transparent', type: 'Boolean', defaultValue: false },
    baseColor: { label: 'Color', type: 'Color', defaultValue: { r: 0.94, g: 0.94, b: 0.94 } },

    baseFalloff: { label: 'Falloff', type: 'Boolean', defaultValue: false },
    baseFalloffMap: { label: 'Image', type: 'Plug', plug: 'Image' },
    baseFalloffColor: { label: 'Falloff Color', type: 'Color', defaultValue: { r: 0.94, g: 0.94, b: 0.94 }, animatable: true },

    opacityMap: { label: 'Image', type: 'Plug', plug: 'Image' },
    opacityFactor: { label: 'Factor', type: 'Number', defaultValue: 1.0, maxValue: 1.0, minValue: 0.0, step: 0.01, animatable: true },

    opacityFalloffMap: { label: 'Image', type: 'Plug', plug: 'Image' },
    opacityFalloffFactor: { label: 'Falloff Factor', type: 'Number', defaultValue: 1.0, maxValue: 1.0, minValue: 0.0, step: 0.01, animatable: true },

    depthWrite: { label: 'Depth Write', type: 'Boolean', defaultValue: true },
    depthTest: { label: 'Depth Test', type: 'Boolean', defaultValue: true },

    specularMap: { label: 'Image', type: 'Plug', plug: 'Image' },
    specularColor: { label: 'Color', type: 'Color', defaultValue: { r: 1, g: 1, b: 1 }, animatable: true },

    roughness: { label: 'Roughness', type: 'Number', defaultValue: 0.25, minValue: 0.0, maxValue: 1.0, step: 0.01, animatable: true },
    roughnessMap: { label: 'Image', type: 'Plug', plug: 'Image' },

    metallic: { label: 'Metallic', type: 'Number', defaultValue: 0.0, minValue: 0.0, maxValue: 1.0, step: 0.01, animatable: true },
    metallicMap: { label: 'Image', type: 'Plug', plug: 'Image' },

    clearCoat: { label: 'Thickness', type: 'Number', defaultValue: 0.0, minValue: 0.0, maxValue: 1.0, step: 0.01, animatable: true },
    clearCoatRoughness: { label: 'Roughness', type: 'Number', defaultValue: 0.25, minValue: 0.0, maxValue: 1.0, step: 0.01, animatable: true },

    lightMap:  { label: 'Image', type: 'Plug', plug: 'Image' },
    ambientColor2: { label: 'Color', type: 'Color', animatable: true, defaultValue: { r: 0, g: 0, b: 0 } },

    emissiveMap:  { label: 'Image', type: 'Plug', plug: 'Image' },
    emissiveColor: { label: 'Color', type: 'Color', animatable: true,  defaultValue: { r: 0, g: 0, b: 0 } },
    emissiveScale: { label: 'Scale', type: 'Number', defaultValue: 1.0, minValue: 0.0, maxValue: 100.0, step: 0.1, animatable: true },
    emissiveLabel: { type: 'Label', align: 'right', defaultValue: 'Emissive uses the second UV channel.' },

    translucencyColor: { label: 'Color', type: 'Color', animatable: true, defaultValue: { r: 0, g: 0, b: 0 } },
    translucencyMap:  { label: 'Image', type: 'Plug', plug: 'Image' },
    translucencyNormalAlpha: { label: 'Normal Alpha', type: 'Number', defaultValue: 0.75, minValue: 0.0, maxValue: 1.0, step: 0.05, animatable: true },
    translucencyNormalPower: { label: 'Normal Power', type: 'Number', defaultValue: 2.0, minValue: 0.01, maxValue: 100.0, step: 0.05, animatable: true },
    translucencyViewAlpha: { label: 'View Alpha', type: 'Number', defaultValue: 0.75, minValue: 0.0, maxValue: 1.0, step: 0.05, animatable: true },
    translucencyViewPower: { label: 'View Power', type: 'Number', defaultValue: 2.0, minValue: 0.01, maxValue: 100.0, step: 0.05, animatable: true },

    bumpMap:  { label: 'Image', type: 'Plug', plug: 'Image' },
    bumpFactor: { label: 'Scale Factor', type: 'Number', defaultValue: 0.03, minValue: -5.0, maxValue: 5.0, step: 0.001, animatable: true },

    normalMap: { label: 'Image', type: 'Plug', plug: 'Image' },
    normalFactor: { label: 'Scale Factor', type: 'Number', defaultValue: 1.0, minValue: -100.0, maxValue: 100.0, step: 0.001, animatable: true },
    normalRedFlip: { label: "Red Channel Flip", type: "Boolean", defaultValue: false },
    normalGreenFlip: { label: "Green Channel Flip", type: "Boolean", defaultValue: false },

    anisotropyLabel: { type: 'Label', align: 'right', defaultValue: 'Anisotropy requires the Tangent operator.' },
    anisotropyMap: { label: 'Image', type: 'Plug', plug: 'Image' },
    anisotropy: { label: 'Offset', type: 'Number', defaultValue: 0.0, minValue: -1.0, maxValue: 1.0, step: 0.025, animatable: true },

    anisotropyRotationMap:  { label: 'Image', type: 'Plug', plug: 'Image' },
    anisotropyRotation: { label: 'Rotation Offset', type: 'Number', defaultValue: 0.0, minValue: -1.0, maxValue: 1.0, step: 0.025, animatable: true },

    overrideEnvironment: { label: 'Override Environment', type: 'Boolean', defaultValue: false },
    //environmentMap: { label: "Environment Map", type: 'Node', filter: environmentMapFilter },
  },
};

const MaterialReference = {
  schema: {
    defaultColor: { label: 'Default Color', type: 'Color', defaultValue: { r: 1, g: 1, b: 1 } },
    reference: { type: 'Plug', plug: 'Material', label: 'Reference' },
  },
  update: (operator, primitive) => {
    primitive.color = operator.defaultColor;
    //return operator.reference || primitive.color = operator.defaultColor;
  },
};

const Reference = {
  schema: {
    defaultColor: { label: 'Default Color', type: 'Color', defaultValue: { r: 1, g: 1, b: 1 } },
    reference: { type: 'Plug', plug: 'Material', label: 'Reference' },
  },
  update: (operator, primitive) => {
    if (operator.reference) return operator.reference;
    primitive.defaultColor = operator.defaultColor;
  },
};

const EnvironmentMap = {
  schema: {
    thumbnailImage: { label: 'Thumbnail', type: 'Plug', plug: 'Image' },

    irradianceCubeMap: { label: 'Irradiance', type: 'Plug', plug: 'Material' }, //filter: cubeMapFilter },
    specularCubeMap: { label: 'Specular', type: 'Plug', plug: 'Material' }, //filter: cubeMapFilter },
    intensity: { label: "Intensity", type: 'Number', defaultValue: 1.0, minValue: 0.001, maxValue: 100.0, step: 0.1, animatable: true },

    //giImage:   { label: 'Global Illumination', type: 'Node', initialValue: null, filter: exo.material.ImageUtils.nodeFilter },
    //// these two maps should usually be the global illumination map.
    //reflectionImage:   { label: 'Reflection', type: 'Node', initialValue: null, filter: exo.material.ImageUtils.nodeFilter },
    //refractionImage:   { label: 'Refraction', type: 'Node', initialValue: null, filter: exo.material.ImageUtils.nodeFilter },
  },
};

const CubeMap = {
  schema: {
    map0: { label: 'Map ( x)', type: 'Plug', plug: 'Image' },
    map1: { label: 'Map (-x)', type: 'Plug', plug: 'Image' },
    map2: { label: 'Map ( y)', type: 'Plug', plug: 'Image' },
    map3: { label: 'Map (-y)', type: 'Plug', plug: 'Image' },
    map4: { label: 'Map ( z)', type: 'Plug', plug: 'Image' },
    map5: { label: 'Map (-z)', type: 'Plug', plug: 'Image' },
  },
  update: (operator, primitive, { node }) => {
    primitive.maps = [
      operator.map0, operator.map1, operator.map2, operator.map3, operator.map4, operator.map5,
    ];
  },
};

const ProxyReference = {
  schema: {
    webgl: { type: 'Plug', label: 'WebGL Material', plug: 'Material' },
    vray: { type: 'Plug', label: 'VRay Material', plug: 'Material' },
  },
  update: (operator, primitive) => {
    return operator.webgl || primitive;
  },
};

const Standard = {
  schema: {
    diffuseColor: { label: 'Color', type: 'Color', defaultValue: { r: 0.94, g: 0.94, b: 0.94 } },
  },
};

const MultiID = {
  schema: {

    defaultColor: { label: 'Default Color', type: 'Color', defaultValue: { r: 0.5, g: 0.5, b: 0.5 } },

    material0: { type: 'Plug', plug: 'Material', label: 'Material ID 0' },
    material1: { type: 'Plug', plug: 'Material', label: 'Material ID 1' },
    material2: { type: 'Plug', plug: 'Material', label: 'Material ID 2' },
    material3: { type: 'Plug', plug: 'Material', label: 'Material ID 3' },
    material4: { type: 'Plug', plug: 'Material', label: 'Material ID 4' },
    material5: { type: 'Plug', plug: 'Material', label: 'Material ID 5' },
    material6: { type: 'Plug', plug: 'Material', label: 'Material ID 6' },
    material7: { type: 'Plug', plug: 'Material', label: 'Material ID 7' },
    material8: { type: 'Plug', plug: 'Material', label: 'Material ID 8' },
    material9: { type: 'Plug', plug: 'Material', label: 'Material ID 9' },
    material10: { type: 'Plug', plug: 'Material', label: 'Material ID 10' },
    material11: { type: 'Plug', plug: 'Material', label: 'Material ID 11' },
    material12: { type: 'Plug', plug: 'Material', label: 'Material ID 12' },
    material13: { type: 'Plug', plug: 'Material', label: 'Material ID 13' },
    material14: { type: 'Plug', plug: 'Material', label: 'Material ID 14' },
    material15: { type: 'Plug', plug: 'Material', label: 'Material ID 15' },
    material16: { type: 'Plug', plug: 'Material', label: 'Material ID 16' },
    material17: { type: 'Plug', plug: 'Material', label: 'Material ID 17' },
    material18: { type: 'Plug', plug: 'Material', label: 'Material ID 18' },
    material19: { type: 'Plug', plug: 'Material', label: 'Material ID 19' },
    material20: { type: 'Plug', plug: 'Material', label: 'Material ID 20' },
    material21: { type: 'Plug', plug: 'Material', label: 'Material ID 21' },
    material22: { type: 'Plug', plug: 'Material', label: 'Material ID 22' },
    material23: { type: 'Plug', plug: 'Material', label: 'Material ID 23' },
    material24: { type: 'Plug', plug: 'Material', label: 'Material ID 24' },
    material25: { type: 'Plug', plug: 'Material', label: 'Material ID 25' },
    material26: { type: 'Plug', plug: 'Material', label: 'Material ID 26' },
    material27: { type: 'Plug', plug: 'Material', label: 'Material ID 27' },
    material28: { type: 'Plug', plug: 'Material', label: 'Material ID 28' },
    material29: { type: 'Plug', plug: 'Material', label: 'Material ID 29' },

    multiID: { type: 'Boolean', label: 'Is MultiID', defaultValue: true },
  },
};

const VRmat = {
  schema: {
    visMatZipFile:  { type: 'File',  hidden: true },
    viewColor:      { type: 'Color', defaultValue: { r: 0.94, g: 0.94, b: 0.94 }, label: 'Viewport Color' },
  },
};

export default { Material, Physical, MaterialReference, Reference, EnvironmentMap,
  CubeMap, Standard, ProxyReference, MultiID, 'vray/VRmat': VRmat, };



// WEBPACK FOOTER //
// ./src/operators/Material.js